import { Trip } from './../classes.js';
import { notification } from './../function/notification.js';
import { api } from './../function/api.js';
import { can_display, trigger_text_editor, trigger_sort, strip_html, start_loading, end_loading } from './../function/common.js';

export class cTripOrganize {
	constructor() {
		this.trip_id = null;
		this.trigger = null;
		this.blocks = null;
		const self = this;
		
		/*Open & Close*/
		$('body').on('click', '.trip_organize--open', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.open();
		})
		
		$('body').on('click', '.trip_organize--close', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.close();
		})
		
		$('body').on('click', '.delete--b', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.block_delete($(this));
		})
		
		$('body').on('click', '.delete--e', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.element_delete($(this));
		})
		
		/*Sorting*/
		$(".trip_organize--full").sortable({
			items: '.trip_organize--block'
			, handle: '.org__options--b .drag--b'
			, update: function() {
				self.update_sort();
			}
		});
	}
	
	open(){
		$('#trip_organize').css("display", "flex").hide().fadeIn(200);
		
		this.set();
	}
	
	close(){
		$('#trip_organize').fadeOut(200);
	}
	
	set(){
		let $block = '';
		let $element = '';
		const self = this;
		this.blocks = Trip.content.b;
		$('#org_trip_system').html('');
		
		//BUILD BLOCKS FOR THE ORGANIZER
		const sortedBlocks = Object.entries(this.blocks).sort((a, b) => a[1]['order'] - b[1]['order']);
		for (const [block_id, block] of sortedBlocks) {
			const sortedElements = Object.entries(block.e).sort((a, b) => a[1]['order'] - b[1]['order']);
			
			$block = $('<div/>', {
				'class': 'trip_organize--block',
				'data-block_id': block.id,
				'data-block_order': block.order,
			});
			$block.append(
				`<div class="org__options--b">
					<span class="drag--b material-symbols-outlined">drag_pan</span>
					<span class="delete--b material-symbols-outlined">delete</span>
				</div>`
			);
			$block.append(`<div class="org__header">${block.name}</div>`);
			
			for (const [el_id, el] of sortedElements) {
				if(el.id != null){
					
					$element = $('<div/>', {
						'class': 'trip_organize--element',
						'data-el_id': el.id,
						'data-block_id': block.id,
						'data-el_order': el.order
					});
					
					switch(el.type){
						case 'text':
							$element.append(`<p><strong>Text:</strong> ${strip_html(el.c.text).slice(0, 24)} ... </p>`);
							break;
						case 'event':
							$element.append(`<p><strong>Event:</strong> ${strip_html(el.c.name).slice(0, 24)} ... </p>`);
							break;
						case 'image':
							$element.append(`<p><strong>Image:</strong> ${strip_html(Trip.media.files[el.c.media_id].path).slice(0, 24)} ... </p>`);
							break;
						case 'video':
							$element.append(`<p><strong>Video</strong></p>`);
							break;
						case 'youtube':
							$element.append(`<p><strong>YouTube</strong></p>`);
							break;
					}
				
					$element.append(
						`<div class="org__options--e">
							<span class="drag--e material-symbols-outlined">drag_pan</span>
							<span class="delete--e material-symbols-outlined">delete</span>
						</div>`
					);
					
					$block.append($element);
				}
			}
			
			$('#org_trip_system').append($block);
		}
		
		$(".trip_organize--block").sortable({
			items: '.trip_organize--element'
			, handle: '.org__options--e .drag--e'
			, update: function() {
				self.update_sort();
			}
		});
	}
	
	update_sort(){
		let b = 1;
		let i = 1;
		let block_id = 0;
		let el_id = 0;
		
		//update order of each block
		$(".trip_organize--block").each(function(index){
			
			//update for object
			block_id = $(this).attr('data-block_id');
			Trip.content.b[block_id].order = b;
			
			b++;
			
			//update order of each element
			i = 1;
			$(this).find('.trip_organize--element').each(function(index){
				
				//update for object
				el_id = $(this).attr('data-el_id');
				Trip.content.b[block_id].e[el_id].order = i;
				
				i++;
			});
		});
		
		Trip.render_view(Trip.view);
	}
	
	
	async block_delete($dom){
		let $target = $dom.closest('.trip_organize--block');
		let block_id = $target.data('block_id');
		
		if(isNaN(block_id)){
			
			delete Trip.content.b[block_id];
			$(`.trip__block[data-block_id="${block_id}"]`).remove();
			$(`.trip_organize--block[data-block_id="${block_id}"]`).remove();
			
		}else{
			
			//this has been saved, remove it from the database then from object and display
			let delete_block = new FormData();
			delete_block.append('block_id', block_id);
			
			//post
			let response = await api('/api/block/delete', delete_block);
			
			//response
			if(response.error){
				notification(response.message.join('<br/>'));
			}else{
				
				delete Trip.content.b[block_id];
				$(`.trip__block[data-block_id="${block_id}"]`).remove();
				$(`.trip_organize--block[data-block_id="${block_id}"]`).remove();
				
			}
			
		}
	}
	
	async element_delete($dom){
		let $target = $dom.closest('.trip_organize--element');
		let el_id = $target.data('el_id');
		let block_id = $target.data('block_id');
		
		if(isNaN(el_id)){
			
			delete Trip.content.b[block_id].e[el_id];
			$(`.e[data-el_id="${el_id}"][data-block_id="${block_id}"]`).remove();
			$(`.trip_organize--element[data-el_id="${el_id}"][data-block_id="${block_id}"]`).remove();
			
		}else{
			
			//this has been saved, remove it from the database then from object and display
			let delete_element = new FormData();
			delete_element.append('el_id', el_id);
			delete_element.append('block_id', block_id);
			
			//post
			let response = await api('/api/element/delete', delete_element);
			
			//response
			if(response.error){
				notification(response.message.join('<br/>'));
			}else{
				
				delete Trip.content.b[block_id].e[el_id];
				$(`.e[data-el_id="${el_id}"][data-block_id="${block_id}"]`).remove();
				$(`.trip_organize--element[data-el_id="${el_id}"][data-block_id="${block_id}"]`).remove();
				
			}
			
		}
	}
}